import type {CatalogueFeature} from "@devplaninc/codeup"
import {knowledgeFeatureCataloguePath} from "@/app/paths"

export function catalogueFeatureLabel(feature: CatalogueFeature | undefined): string | undefined {
  if (!feature) return undefined
  if (feature.title.trim()) return feature.title.trim()
  const description = feature.description.trim()
  if (!description) return "Untitled feature"
  return description.length > 60 ? `${description.slice(0, 57)}...` : description
}

export function catalogueFeatureHref(companyId: number | undefined, featureId: string): string | undefined {
  if (companyId === undefined || !featureId) return undefined
  return `${knowledgeFeatureCataloguePath(companyId)}?feature=${encodeURIComponent(featureId)}`
}
